import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// @Component({
//   selector: 'ngx-two-columns-layout',
//   styleUrls: ['./two-columns.layout.scss'],
//   template: `
//     <nb-layout windowMode>
//       <nb-layout-header fixed>
//         <ngx-header></ngx-header>
//       </nb-layout-header>

//       <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive>
//         <ng-content select="nb-menu"></ng-content>
//       </nb-sidebar>

//       <nb-layout-column class="small">
//       </nb-layout-column>

//       <nb-layout-column>
//         <ng-content select="router-outlet"></ng-content>
//       </nb-layout-column>

//       <nb-layout-footer fixed>
//         <ngx-footer></ngx-footer>
//       </nb-layout-footer>

//     </nb-layout>
//   `,
// })
@Component({
  selector: 'ngx-two-columns-layout',
  styleUrls: ['./two-columns.layout.scss'],
  template: `
    <nb-layout windowMode>
      <!-- Header: only show if not on login page -->
      <nb-layout-header fixed *ngIf="!isLoginPage()">
        <ngx-header></ngx-header>
      </nb-layout-header>

      <!-- Sidebar: only show if not on login page -->
      <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive *ngIf="!isLoginPage()">
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <!-- First Column: always visible -->
      <nb-layout-column class="small">
      </nb-layout-column>

      <!-- Main Content Column: always visible -->
      <nb-layout-column>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <!-- Footer: only show if not on login page -->
      <nb-layout-footer fixed *ngIf="!isLoginPage()">
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
})
export class TwoColumnsLayoutComponent implements OnInit{
  constructor(private router: Router) {}

  ngOnInit() {
    this.isLoginPage();
  }

  // Method to check if the current route is the login page
  isLoginPage(): boolean {
    return this.router.url === '/login';  // Adjust the URL path if needed
  }
}

